import React, { useState } from 'react';

import { Button } from '$partials/ui';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/global.d.ts').TagCloud}
 */

const TagCloud = ({
    label,
    toggleValue,
    options = [],
    value,
    tagKey
}) => {
    const [showAll, setShowAll] = useState(false);

    if (options.length < 1) {
        return null;
    }

    return (
        <fieldset
            className='flex flex-col'
            key={tagKey}>
            {label &&
                <legend className='pb-12 sm:pb-16 type-style-s'>
                    {label}
                </legend>
            }

            <div className='flex flex-row flex-wrap gap-8'>
                {(showAll ? options : options?.slice(0, 8))?.map((option, i) => {
                    const isChecked = Boolean(value.find((v) => v === option.value));
                    const disabled = options?.find((f) => f.value === String(option.value))?.disabled;

                    if (label?.toLowerCase() === 'colour') {
                        return (
                            <div
                                className='pr-24'
                                key={option.id}>
                                <Button
                                    className={`px-12 pt-12 pb-28 rounded-[3px] border hover:border-border-active disabled:hover:border-transparent ${isChecked ? 'border-border-active' : 'border-transparent'}`}
                                    disabled={disabled}
                                    onClick={() => {
                                        if (typeof toggleValue === 'function') {
                                            toggleValue(option.value);
                                        }
                                    }}>
                                    <span
                                        className='h-20 w-20 block'
                                        style={{
                                            backgroundColor: option.colour
                                        }}/>
                                </Button>
                            </div>
                        );
                    }

                    return (
                        <Button
                            className={`disabled:text-text-default-secondary disabled:hover:border disabled:hover:border-border-default disabled:hover:text-text-default-secondary disabled:hover:bg-transparent ${isChecked ? 'button-filled' : 'button-outline'}`}
                            disabled={disabled}
                            key={option.id}
                            onClick={() => {
                                if (typeof toggleValue === 'function') {
                                    toggleValue(option.value);
                                }
                            }}>
                            {option.label}
                        </Button>

                    );
                })}
                {options?.length > 8 && !showAll && (
                    <Button
                        as='button'
                        className='button-outline'
                        onClick={() => setShowAll(!showAll)}>
                        {!showAll ? `+(${options.length - 8})` : ''}
                    </Button>
                )}
            </div>
        </fieldset>
    );
};

/* ========================================================================= */
/* Exports */
/* ========================================================================= */

export default TagCloud;
